import React from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas'
import { connect } from 'react-redux'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import { globalKeyStore } from '../../redux/actions/globalState'
import { formatDate } from './FormatDate'

function OffCanvas(props) {
    const { isCanvasShow, dispatch, stDate, enDate } = props

    const handleClose = () => dispatch(globalKeyStore({ isCanvasShow: !isCanvasShow }))
    const startDate = (val) => {
        dispatch(globalKeyStore({ startDate: val }))
        if(endDate) {
            let localeDate = new Date(val)
            let localEndDT = new Date(enDate)
            if (localeDate.getTime() > localEndDT.getTime()) {
                let newDate = localeDate.setDate(localeDate.getDate() + 1)
                let formatDt = formatDate(new Date(newDate))
                dispatch(globalKeyStore({ endDate: formatDt.toString() }))
            }
        }
    }
    const endDate = (val) => dispatch(globalKeyStore({ endDate: val }))

    return (
        <>
            <Offcanvas show={isCanvasShow} onHide={handleClose} placement='end'>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Filters By</Offcanvas.Title>
                </Offcanvas.Header>
                <div className="mb-3 bg-light">
                    <Offcanvas.Body>
                        <h5>Select Date Range</h5>
                        <div className="input-group">
                            <input type="date" className="form-control" placeholder="Start Date" id="datepicker" onChange={(e) => startDate(e.target.value)} />
                            <input type="date" className="form-control" placeholder="End Date" id="datepicker" min={stDate?stDate:''} value={enDate?enDate:''} onChange={(e) => endDate(e.target.value)} />
                        </div>
                    </Offcanvas.Body>
                </div>
                <Offcanvas.Body>
                    <h5 className=" "> Filter By Events </h5>
                    <ul className="list-group">
                        <li className="list-group-item">
                            <input className="form-check-input me-1" type="checkbox" value="" id="firstCheckbox" />
                            <label className="form-check-label" htmlFor="firstCheckbox">First Event Title</label>
                        </li>
                        <li className="list-group-item">
                            <input className="form-check-input me-1" type="checkbox" value="" id="secondCheckbox" />
                            <label className="form-check-label" htmlFor="secondCheckbox">Second Event Title</label>
                        </li>
                        <li className="list-group-item">
                            <input className="form-check-input me-1" type="checkbox" value="" id="thirdCheckbox" />
                            <label className="form-check-label" htmlFor="thirdCheckbox">Third Event Title</label>
                        </li>
                    </ul>
                </Offcanvas.Body>
                <div className="p-4">
                    <button className="btn btn-primary w-100">Apply</button>
                </div>
            </Offcanvas>
        </>
    )
}

OffCanvas.propTypes = {
    dispatch: PropTypes.func,
    notify: PropTypes.func,
    isCanvasShow: PropTypes.bool,
    stDate: PropTypes.string,
    enDate: PropTypes.string,
}

OffCanvas.defaulProps = {
    dispatch: noop,
    notify: noop,
    isCanvasShow: false,
    stDate: '',
    enDate: '',
}

function mapStateToProps({ globalReducers }) {
    return {
        isCanvasShow: globalReducers?.isCanvasShow,
        stDate: globalReducers?.startDate,
        enDate: globalReducers?.endDate,
    }
}

export default connect(mapStateToProps)(OffCanvas)